interface ILimitSettingsState {
  slippage: string | number;
  slippageValid: boolean;
  deadline: string | number;
  deadlineValid: boolean;
  sendTokens: boolean;
}

export enum LimitSettingsActions {
  SetSlippage = 'LIMIT_SET_SLIPPAGE',
  SetSlippageValid = 'LIMIT_SET_SLIPPAGE_VALID',
  SetDeadline = 'LIMIT_SET_DEADLINE',
  SetDeadlineValid = 'LIMIT_SET_DEADLINE_VALID',
  ToggleSendTokens = 'LIMIT_TOGGLE_SEND_TOKENS',
}

export const getInitialLimitSettingsState = (
  slippage: number,
  deadline: number,
  sendTokens: boolean,
): ILimitSettingsState => ({
  slippage,
  slippageValid: true,
  deadline,
  deadlineValid: true,
  sendTokens,
});

export const limitSettingsReducer = (
  state: ILimitSettingsState,
  action: { payload?: any; type: LimitSettingsActions }
): ILimitSettingsState => {
  switch (action.type) {
  case LimitSettingsActions.SetSlippage:
    return {
      ...state,
      slippage: action.payload,
    };
  case LimitSettingsActions.SetSlippageValid:
    return {
      ...state,
      slippageValid: action.payload,
    };
  case LimitSettingsActions.SetDeadline:
    return {
      ...state,
      deadline: action.payload,
    };
  case LimitSettingsActions.SetDeadlineValid:
    return {
      ...state,
      deadlineValid: action.payload,
    };
  case LimitSettingsActions.ToggleSendTokens:
    return {
      ...state,
      sendTokens: !state.sendTokens,
    };
  default:
    return state;
  }
};
